module.exports = "<h5 [style.color]=\"slice.color\">{{ slice.label }}</h5>\n<p>\n  amount: <strong>{{ slice.amount }}</strong><br>\n  <a href=\"javascript:void(0)\" (click)=\"onSliceSelect()\">Select</a>\n</p>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/andyperlitch/repos/ngx-d3-tooltip/src/app/components/slice-tooltip/slice-tooltip.component.html
// module id = ../../../../../src/app/components/slice-tooltip/slice-tooltip.component.html
// module chunks = main